// import { applications } from '../../../constants/app.constants';

import * as R from 'ramda';

export default function ControlAdminController(
  $q,
  $scope,
  loaderService,
  editControlDialog,
  ssDialogService,
  userService,
  controlDataService,
  controlSharedModelService,
  controlSettingsDialog,
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.groupId = 54;
  vm.controls = [];

  vm.handleShowAddControlClick = _handleShowAddControlClick;
  vm.handleShowSettings = _handleShowSettings;

  _activate();

  function _activate() {
    const dfdActivate = $q.defer();

    _initEventListeners();
    _initPermissions();

    const getControls = _refreshControls();
    $q.all([
      getControls,
    ]).then(() => {
      vm.appIsLoaded = true;
      dfdActivate.resolve();
    });

    return dfdActivate.promise;
  }

  function _initEventListeners() {
    $scope.$on('refreshControls', _refreshControls);
    $scope.$on('refreshControlTypes', _refreshControls);
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('policyRiskAssessment')
      .then((permissions) => {
        loaderService.showViewLoader = false;
        vm.permissions = permissions;
      });
  }

  function _handleShowAddControlClick($event) {
    loaderService.showViewLoader = true;
    const control = { customerControlId: 0 };
    $q.all([
      // controlDataService.getControlTypes(),
      // riskDataService.getRisks(),
      controlDataService.getControlById(control.customerControlId),
      controlDataService.getControlTypeDefaults()
    ]).then((response) => {
      loaderService.showViewLoader = false;
      // eslint-disable-next-line max-len
      control.controlPreventiveEffectivenessId = response[1].data.controlPreventiveEffectiveness.controlPreventiveEffectivenessId;
      // eslint-disable-next-line max-len
      control.controlDetectiveEffectivenessId = response[1].data.controlDetectiveEffectiveness.controlDetectiveEffectivenessId;
      // eslint-disable-next-line max-len
      control.controlCorrectiveEffectivenessId = response[1].data.controlCorrectiveEffectiveness.controlCorrectiveEffectivenessId;
      // eslint-disable-next-line max-len
      control.controlAdministrativeNatureId = response[1].data.controlAdministrativeNature.controlAdministrativeNatureId;
      control.controlTechnicalNatureId = response[1].data.controlTechnicalNature.controlTechnicalNatureId;
      control.controlPhysicalNatureId = response[1].data.controlPhysicalNature.controlPhysicalNatureId;
      control.controlPrimaryControlTypeId = response[1].data.controlPrimaryControlType.controlPrimaryControlTypeId;
      // eslint-disable-next-line max-len
      control.controlCompensatingControlTypeId = response[1].data.controlCompensatingControlType.controlCompensatingControlTypeId;
      control.controlReviewSchedule = response[1].data.controlReviewSchedule;
      control.controlReviewType = response[1].data.controlReviewType;
      control.controlResult = response[1].data.controlResult;
      ssDialogService.dialogs.controlAdmin.editControlDialog = ssDialogService.alert(
        editControlDialog.getOptions($event, {
          control,
          controlTypes: response[0].data.CustomerControlTypes,
          risks: response[0].data.CustomerRiskData,
          controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
          controlReviewTypes: controlSharedModelService.ControlReviewTypes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlDialog);
    });
  }

  function _handleShowSettings($event) {
    const promises = [
      controlDataService.getControlWeights(),
      controlDataService.getControlTypes(),
    ];

    $q.all(promises)
      .then((response) => {
        ssDialogService.dialogs.controlAdmin.settingControlDialog = ssDialogService.alert(
          controlSettingsDialog.getOptions($event, {
            controlTypes: response[0].data.result,
            controlTypeList: response[1].data.result
          })
        );
        ssDialogService.show(ssDialogService.dialogs.controlAdmin.settingControlDialog);
      });
  }

  function _refreshControls() {
    const dfdItem = $q.defer();
    controlDataService.init().then((response) => {
      vm.controlTypeList = response.data.ControlTypes.result;
      _initPage(response);
      transformControlTypeList();
      dfdItem.resolve();
    });

    return dfdItem.promise;
  }

  function _initPage(getControlInitResponse) {
    // return controlDataService.initControlAdmin().then((getControlInitResponse) => {
    if (getControlInitResponse.data.ControlResults) {
      vm.controlResults = getControlInitResponse.data.ControlResults.result;
      controlSharedModelService.ControlResults = vm.controlResults;
    }

    if (getControlInitResponse.data.ControlPreventiveEffectivenesses) {
      vm.controlPreventiveEffectivenesses = getControlInitResponse.data.ControlPreventiveEffectivenesses.result;
      controlSharedModelService.ControlPreventiveEffectivenesses = vm.controlPreventiveEffectivenesses;
    }

    if (getControlInitResponse.data.ControlDetectiveEffectivenesses) {
      vm.controlDetectiveEffectivenesses = getControlInitResponse.data.ControlDetectiveEffectivenesses.result;
      controlSharedModelService.ControlDetectiveEffectivenesses = vm.controlDetectiveEffectivenesses;
    }

    if (getControlInitResponse.data.ControlCorrectiveEffectivenesses) {
      vm.controlCorrectiveEffectivenesses = getControlInitResponse.data.ControlCorrectiveEffectivenesses.result;
      controlSharedModelService.ControlCorrectiveEffectivenesses = vm.controlCorrectiveEffectivenesses;
    }

    if (getControlInitResponse.data.ControlAdministrativeNatures) {
      vm.controlAdministrativeNatures = getControlInitResponse.data.ControlAdministrativeNatures.result;
      controlSharedModelService.ControlAdministrativeNatures = vm.controlAdministrativeNatures;
    }

    if (getControlInitResponse.data.ControlPhysicalNatures) {
      vm.controlPhysicalNatures = getControlInitResponse.data.ControlPhysicalNatures.result;
      controlSharedModelService.ControlPhysicalNatures = vm.controlPhysicalNatures;
    }

    if (getControlInitResponse.data.ControlTechnicalNatures) {
      vm.controlTechnicalNatures = getControlInitResponse.data.ControlTechnicalNatures.result;
      controlSharedModelService.ControlTechnicalNatures = vm.controlTechnicalNatures;
    }

    if (getControlInitResponse.data.ControlPrimaryControlTypes) {
      vm.controlPrimaryControlTypes = getControlInitResponse.data.ControlPrimaryControlTypes.result;
      controlSharedModelService.ControlPrimaryControlTypes = vm.controlPrimaryControlTypes;
    }

    if (getControlInitResponse.data.ControlCompensatingControlTypes) {
      vm.controlCompensatingControlTypes = getControlInitResponse.data.ControlCompensatingControlTypes.result;
      controlSharedModelService.ControlCompensatingControlTypes = vm.controlCompensatingControlTypes;
    }

    if (getControlInitResponse.data.ControlReviewSchedules) {
      vm.controlReviewSchedules = getControlInitResponse.data.ControlReviewSchedules.result;
      controlSharedModelService.ControlReviewSchedules = vm.controlReviewSchedules;
    }

    if (getControlInitResponse.data.ControlReviewTypes) {
      vm.controlReviewTypes = getControlInitResponse.data.ControlReviewTypes.result;
      controlSharedModelService.ControlReviewTypes = vm.controlReviewTypes;
    }

    if (getControlInitResponse.data.ControlTypes) {
      vm.controlTypes = getControlInitResponse.data.ControlTypes.result;
      controlSharedModelService.ControlTypes = vm.controlTypes;
    }
    // });
  }

  function transformControlTypeList() {
    R.forEach(
      (type) => {
        controlSharedModelService.transformControl(type);
        if (type.customerControls && type.customerControls.length > 0) {
          R.forEach(
            (item) => {
              item.customerControlType = type;
              controlSharedModelService.transformControl(item);
            },
            type.customerControls
          );
        }
      },
      vm.controlTypeList
    );
  }
}

ControlAdminController.$inject = [
  '$q',
  '$scope',
  'loaderService',
  'editControlDialog',
  'ssDialogService',
  'userService',
  'controlDataService',
  'controlSharedModelService',
  'controlSettingsDialog',
];
